import Navbar from "../../layout/Navbar";
import HomeSearch from "../../components/elements/HomeSearch";
import hero from "../../assets/images/e-puja.png";
import namaste from "../../assets/images/namaste.png";
import SearchCapsules from "../../components/elements/SearchCapsules";
import EpujaCard from "../../components/cards/EpujaCard";
import useWidth from "../../hooks/useWidth";
import MobileView from '../mobile/Epuja'
import { useFetch } from '../../hooks/useFetch'
import { getEpujaList } from "../../apis";
import { useState } from "react";
import Icon from "../../components/Icon";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import Loader from "../../components/elements/Loader";

export default () => {
  const [ filters, setFilters ] = useState({ search: null })
  const [epuja,,loading] = useFetch(getEpujaList, {}, filters)

  const width = useWidth();
  return (
    <>
    {
      <Loader loading={loading} />
    }
    {width < 992 && <MobileView data={epuja} filters={filters} setFilters={setFilters} />}
      {width > 992 && (
        <>
          <Navbar />
          <div className="hero-section ">
            <img
              src={hero}
              className="w-100 h-100 hero-img bg-backdrop"
              alt=""
            />
            <div
              className=" hero-inner d-flex justify-content-center  flex-column"
              style={{ position: "relative" }}
            >
              <div className="d-flex justify-content-center align-items-center flex-column">
                <img src={namaste} alt="" />
              </div>
              <div className="d-flex w-100 justify-content-center">
                <div className="d-flex  w-100 flex-column mt-4">
                  <div className="w-100 d-flex justify-content-center">
                    <HomeSearch placeholder="Search E Puja" onSearch={ search => setFilters({ search })} />
                  </div>

                  <div className="mt-3 d-flex justify-content-center flex-column">
                    <h4 className="text-center text-light">Recent Searches</h4>
                    <div className="d-flex flex-wrap container mt-4">
                      <SearchCapsules />
                      <SearchCapsules />
                      <SearchCapsules />
                      <SearchCapsules />
                      <SearchCapsules />
                      <SearchCapsules />
                      <SearchCapsules />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="e-puja-section">
            <h3 className="my-5 text-center custom-text-color">
              Find Your Remedy For Peace & Prosperety
            </h3>
          </div>

          {filters.search && <h4 className="container">Search: { filters.search } <Icon icon={faXmark} className="ms-3 cursor-pointer" onClick={() => setFilters({})} /></h4>}

          <div className="container">
            <div className="row">
              {
                epuja.data?.map((puja, i) => 
                  <div className="col-md-6 col-sm-12 p-0" key={i}>
                    <EpujaCard data={puja} />
                  </div>
                )
              }
            </div>
          </div>
        </>
      )}
    </>
  );
};
